import React from "react"

import ContactSupportBanner from "~components/contact-support-banner"
import RequestQuoteBanner from "~components/pages/listing/request-quote-banner"
import type {
    ListingFieldsFragment,
    PublicListingFieldsFragment,
} from "~graphql/generated/graphql"

interface Props {
    readonly listing?:
        | PublicListingFieldsFragment
        | ListingFieldsFragment
        | null
    readonly trackingSource: string
    readonly trackingSourceUrl?: string
}

export default function ListingContactBanner({
    listing,
    trackingSource,
    trackingSourceUrl,
}: Props) {
    const shouldShowContactSupportBanner = !listing?.should_allow_quote_requests

    if (shouldShowContactSupportBanner) {
        return <ContactSupportBanner />
    }

    return (
        <RequestQuoteBanner
            listing={listing}
            trackingSource={trackingSource}
            trackingSourceUrl={trackingSourceUrl}
        />
    )
}
